import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle, Link2 } from "lucide-react";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VincularTelegram() {
  const [params] = useSearchParams();
  const token = params.get("token") || localStorage.getItem("tg_link_token");
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState("idle"); // idle | linking | done | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (user === false) {
      if (token) localStorage.setItem("tg_link_token", token);
      navigate("/login");
    }
  }, [user, token, navigate]);

  const doLink = async () => {
    if (!token) { setState("error"); setMsg("Token ausente. Gere um novo link no bot (/vincular)."); return; }
    setState("linking");
    try {
      const { data } = await api.post("/telegram/link", { token });
      localStorage.removeItem("tg_link_token");
      await refreshUser();
      const bits = [];
      if (data.merged_credits) bits.push(`+${data.merged_credits} créditos`);
      if (data.merged_balance) bits.push(`+R$ ${Number(data.merged_balance).toFixed(2)}`);
      setMsg(bits.length ? `Trouxemos ${bits.join(" e ")} da sua conta do bot.` : "Suas contas agora estão unificadas.");
      setState("done");
    } catch (e) {
      setState("error"); setMsg(apiError(e));
    }
  };

  if (user === null || user === false) {
    return <div className="flex min-h-screen items-center justify-center bg-background"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 grid-bg">
      <div className="w-full max-w-md rounded-xl border border-border bg-card p-8 text-center shadow-sm" data-testid="vincular-telegram">
        <div className="flex justify-center"><Logo /></div>
        <div className="mt-6 flex justify-center">
          {state === "done" ? <CheckCircle2 className="h-14 w-14 text-green-500" />
            : state === "error" ? <XCircle className="h-14 w-14 text-destructive" />
            : <Link2 className="h-14 w-14 text-primary" />}
        </div>
        {state === "done" ? (
          <>
            <h1 className="mt-4 font-heading text-2xl font-bold">Tudo certo! 🦊</h1>
            <p className="mt-2 text-sm text-muted-foreground">{msg}</p>
            <Button className="mt-6 w-full glow-red" onClick={() => navigate("/painel")} data-testid="vincular-done-btn">Ir para o painel</Button>
          </>
        ) : state === "error" ? (
          <>
            <h1 className="mt-4 font-heading text-2xl font-bold">Não deu certo</h1>
            <p className="mt-2 text-sm text-destructive" data-testid="vincular-error">{msg}</p>
            <Button className="mt-6 w-full" variant="outline" onClick={() => navigate("/painel")}>Voltar ao painel</Button>
          </>
        ) : (
          <>
            <h1 className="mt-4 font-heading text-2xl font-bold">Vincular Telegram</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Olá, <b>{user?.name}</b>! Vincular sua conta ao Telegram unifica <b>saldo, créditos e histórico</b> nos dois lugares.
            </p>
            <Button className="mt-6 w-full glow-red" onClick={doLink} disabled={state === "linking"} data-testid="vincular-confirm-btn">
              {state === "linking" && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Vincular agora
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
